module.exports = __webpack_public_path__ + "static/img/Logo (3).b525864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Logo (3).png
// module id = H0bU
// module chunks = 1